import { MyReferralsResponseI, ReferralCodeI } from './interfaces/Referrals';

export const MOCK_REFERRAL_CODE: ReferralCodeI = {
	code: 'K3P9XQ',
	url: 'https://b2c.arcadigital.app/?ref=K3P9XQ',
	reward_snapshot: {
		type: 'plan_contribution',
		display_name: '50€ en tu plan',
		display_description:
			'Cuando un amigo tuyo complete su traspaso a Arca, ingresamos 50€ como aportación extraordinaria directamente en tu plan.',
		amount_numeric: 50.0,
		amount_period_months: null,
		snapshot_taken_at: '2026-05-18T10:30:00Z'
	}
};

// Empty state: user with no referred friends who have started the process yet.
// Enable with REACT_APP_MOCK_REFERRALS_EMPTY=true in .env.local, or from browser console.
export const MOCK_MY_REFERRALS_EMPTY: MyReferralsResponseI = {
	...MOCK_REFERRAL_CODE,
	attributions: [],
	rewards: [],
	stats: {
		total_invited: 0,
		registered: 0,
		converted_transfer: 0,
		converted_new_plan: 0,
		rewards_pending: 0,
		rewards_applied: 0
	}
};

// MOCK_MY_REFERRALS covers the main scenarios for manual QA:
//   attr-1 Carlos   → transfer done, reward validated and scheduled (reward_eligible)
//   attr-2 Lucía    → opened a new plan instead of transferring — no reward (converted_no_reward)
//   attr-3 Andrés   → signed up but hasn't transferred yet (registered)
//   attr-4 Sara     → transfer done, reward already applied — badge overrides to "Premio redimido" (converted + applied reward)
export const MOCK_MY_REFERRALS: MyReferralsResponseI = {
	...MOCK_REFERRAL_CODE,
	attributions: [
		{
			id: 'attr-1',
			referred_first_name: 'Carlos',
			referred_initial_surname: 'G.',
			status: 'reward_eligible',
			referred_plan_type: 'transfer',
			eligible_for_reward: true,
			registered_at: '2026-05-11T09:00:00Z',
			converted_at: '2026-05-21T14:30:00Z'
		},
		{
			id: 'attr-2',
			referred_first_name: 'Lucía',
			referred_initial_surname: 'M.',
			status: 'converted_no_reward',
			referred_plan_type: 'new',
			eligible_for_reward: false,
			registered_at: '2026-05-06T11:00:00Z',
			converted_at: '2026-05-18T10:00:00Z'
		},
		{
			id: 'attr-3',
			referred_first_name: 'Andrés',
			referred_initial_surname: 'P.',
			status: 'registered',
			referred_plan_type: 'transfer',
			eligible_for_reward: false,
			registered_at: '2026-03-22T08:00:00Z',
			converted_at: null
		},
		{
			id: 'attr-4',
			referred_first_name: 'Sara',
			referred_initial_surname: 'R.',
			status: 'converted',
			referred_plan_type: 'transfer',
			eligible_for_reward: true,
			registered_at: '2026-05-16T16:00:00Z',
			converted_at: '2026-05-24T12:00:00Z'
		}
	],
	rewards: [
		{
			id: 'reward-1',
			attribution_id: 'attr-1',
			reward_type: 'plan_contribution',
			amount_numeric: 50.0,
			amount_period_months: null,
			status: 'scheduled',
			scheduled_for: '2026-05-28',
			applied_at: null,
			from_referral_first_name: 'Carlos'
		},
		{
			id: 'reward-2',
			attribution_id: 'attr-4',
			reward_type: 'plan_contribution',
			amount_numeric: 50.0,
			amount_period_months: null,
			status: 'applied',
			scheduled_for: null,
			applied_at: '2026-05-25T10:00:00Z',
			from_referral_first_name: 'Sara'
		}
	],
	stats: {
		total_invited: 4,
		registered: 1,
		converted_transfer: 2,
		converted_new_plan: 1,
		rewards_pending: 1,
		rewards_applied: 1
	}
};
